import type { Cut } from '@/types/cuts';
import { Api, createApi, createUri } from './utils';

import type { CutStatus } from '@consts/cut';

const BASE_URL = createUri(Api.Cuts, '/cuts/V1');

export const cutApi = createApi<CutAPI>(BASE_URL);

export enum CutAPI {
    Activity = 'activity',
    TodayActivity = 'todayActivity',
    Search = 'search',
    Status = 'status',
    History = 'history',
    MaterialsByEmployee = 'materialsByEmployee',
}

export enum CutType {
    Successful = 'Successful Cut',
    Warranty = 'Warranty Claim',
    FailedCut = 'Failed Cut',
    DiagnosticCut = 'Diagnostic Cut',
}

export enum SortDirection {
    Ascending = 'ASC',
    Descending = 'DESC',
}

export interface ViewCutQueryStrings {
    // props: string;
    pageNum?: number;
    pageSize?: number;
    startDate: string;
    endDate: string;
    companyIds?: string;
    resellerIds?: string;
    locationIds?: string;
    materialIds?: string;
    productNames?: string;
    countryName?: string; // potentially multiple;
    status?: CutStatus;
    type?: CutType;
    sortDirection?: SortDirection;
}

export type HistoryResult = {
    cutId: string;
    dbCutId: number;
    status: CutStatus;
    startedDate: string;
    createdDate: string;
    eventDate: string;
    newStatus: CutStatus;
    oldStatus: CutStatus;
};

export const getHistory = cutApi<never, HistoryResult[]>(CutAPI.History, 'GET');

export const searchCuts = cutApi<never, Cut[]>(CutAPI.Search, 'GET');

export const getActivity = cutApi(CutAPI.Activity, 'GET');

export const getTodayActivity = cutApi(CutAPI.TodayActivity, 'GET');

export const updateStatus = cutApi<{ cutIds: string[]; status: CutStatus }, { cutId: string; status: string }[]>(
    CutAPI.Status,
    'PATCH'
);
